import { forwardRef } from 'react';
import { StyledLoader } from './styled';

const Loader = forwardRef((props, ref) => (
  <StyledLoader ref={ref} {...props} />
));

export default Loader;
